import styled from 'styled-components'
import { SubTitle } from '../text'
import { Button } from '../button'

export const Description = styled(SubTitle)`
  white-space: pre-line;
`

export const BulletList = styled.ul`
  font-size: ${props => props.size || '14px'};
  line-height: ${props => props.lineHeight || '16px'};
  color: ${props => props.color || props.theme.colors.text.primaryText};
  font-weight: ${props => props.fontWeight || 400};
  list-style: disc;
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: ${props => (props.isMobile ? '68px 24px 40px 24px' : '68px 32px 50px 32px')};
  background: ${props => props.theme.colors.brand.white};
  border-radius: ${props => (props.isMobile ? '16px 16px 0 0' : '16px')};
  height: ${props => (props.isMobile ? '100%' : 'auto')};
`

export const ContactButton = styled(Button)`
  padding: 0 20px;

  .button-label {
    flex: 1;
    text-align: center;
  }

  &:hover svg path {
    fill: ${props => props.theme.colors.brand.white};
  }
`

export const ContactList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${props => (props.isMobile ? 'stretch' : 'center')};
  gap: 12px;
  margin-top: ${props => (props.isMobile ? 'auto' : '8px')};
  max-height: ${props => (props.isMobile ? 'none' : '264px')};
`
